import { Component, OnInit } from '@angular/core';
// import {} from 'googlemaps'
import { environment } from 'src/environments/environment';
import { VersionCheckService } from './service/version-check.service';
import * as PackageJson from '../../package.json';
import { CookieService } from 'ngx-cookie-service';
import Swal from 'sweetalert2'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  constructor(
    private versionCheckService: VersionCheckService,
    private cookieService: CookieService
  ) { }

  ngOnInit() {
    environment.VERSION = PackageJson.version
    this.versionCheckService.initVersionCheck(environment.versionCheckURL)
    
  }

  REFRESCAR() {
    console.log('version')
   //var version= this.cookieService.get('version')
    if (localStorage.getItem('version')) {
      var version= localStorage.getItem('version')
      this.cookieService.delete('version')
      this.cookieService.delete('VERSION')
      localStorage.setItem('version', environment.VERSION)
      if(environment.VERSION !=version){
        Swal.fire({
          position: 'top',
          title: 'Nueva Versión Disponible',
          confirmButtonText: `Actualizar`
        }).then((result) => {
          if (result.isConfirmed) {
            var version= this.cookieService.get('version')
            localStorage['refreshed'] = true;
            window.localStorage.clear();
            document.location.reload()
            
          }
        })
      }
      
    } else {
      localStorage.setItem('version', environment.VERSION)
    }
  }

}